// localStorage

export const LOCAL_STORAGE_INSPECTIFY_PREFIX = 'inspectify';

export enum LocalStorageKey {
  Theme = 'inspectifyTheme',
  AppInjected = 'inspectifyAppInjectedJwtToken',
  Token = 'inspectifyToken',
  TokenExp = 'inspectifyTokenExp',
  MfaToken = 'inspectifyMfaToken',
  MfaTokenExp = 'inspectifyMfaTokenExp',
  VerificationCodeSentAt = 'inspectifyVerificationCodeSentAt',
  OrderToken = 'inspectifyOrderToken',
  SelectedContractor = 'inspectifySelectedContractor',
  OnboardingId = 'inspectifyOnboardingId',
  SsoRedirect = 'inspectifySsoRedirect',
  MfaRedirect = 'inspectifyMfaRedirect',
}
